import React from "react";
import { useLocation, Routes, Route } from "react-router-dom";

import Notifications from "./containers/Notifications";
import AccessControl from "./iam/AccessControl";
import PublicRoute from "./auth/PublicRoute";
import ProtectedRoute from "./auth/ProtectedRoute";

import { LoginPage } from "./pages";
import { RegisterPage } from "./pages";
import { ForgotPasswordPage } from "./pages";
import { ResetPasswordPage } from "./pages";
import { RegisterOrganizationMemberPage } from "./pages";
import { NotFoundPage } from "./pages";
import { AccountSetupPage } from "./pages";
import { TeamMembersPage } from "./pages";
import { UserAccountPage } from "./pages";
import DashboardPage from "./dashboard/routes/DashboardPage";
import DashboardSettingsPage from "./dashboard/routes/DashboardSettingsPage";
import DeepAnalysisDashboardPage from "./deepAnalysis/routes/DashboardPage";
import NewWebsitePage from "./deepAnalysis/routes/NewWebsitePage";
import FailedCheckPage from "./deepAnalysis/routes/FailedCheckPage";
import ServiceableUrlsPage from "./deepAnalysis/routes/MonitoredUrlsPage";
import UrlClusterPage from "./deepAnalysis/routes/UrlClusterPage";
import SeoAuditReportPage from "./deepAnalysis/routes/SeoAuditReportPage";
import AIContentAnalysisPage from "./llmAnalysis/routes/AIContentAnalysisPage";
import LLMVisibilityAnalysisPage from "./llmAnalysis/routes/LLMVisibilityAnalysisPage";
import VisualSeoAnalysisPage from "./llmAnalysis/routes/VisualSeoAnalysisPage";
import AnalysisPage from "./analysis/routes/AnalysisPage";
import AnalysisReportPage from "./analysis/routes/AnalysisReportPage";
import BacklinksPage from "./backlinks/routes/BacklinksPage";
import TopKeywordsPage from "./topKeywords/routes/TopKeywordsPage";
import KeywordPositionPage from "./trackedKeywords/routes/KeywordPositionPage";
import KeywordResearchPage from "./keywordResearch/routes/KeywordResearchPage";
import SiteSpeedPage from "./siteSpeed/routes/SiteSpeedPage";
import SiteOutagePage from "./outage/routes/SiteOutagePage";
import WhiteLabelPage from "./whiteLabel/routes/WhiteLabelPage";
import SubscriptionPlansPage from "./sales/routes/SubscriptionPlansPage";
import FreeTrialSetupPage from "./sales/routes/FreeTrialSetupPage";
import SubscriptionCheckoutPage from "./sales/routes/SubscriptionCheckoutPage";
import BillingInfoPage from "./sales/routes/BillingInfoPage";
import "./styles/theme.less";

export default function App() {
    const location = useLocation();

    return (
        <div className="app">
            <div className="app-container">
                <Notifications />
                <AccessControl>
                    <Routes location={location}>
                        <Route element={<PublicRoute />}>
                            <Route path="/" element={<LoginPage />} />
                            <Route path="/auth/register" element={<RegisterPage />} />
                            <Route path="/auth/login" element={<LoginPage />} />
                            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/reset-password/:id" element={<ResetPasswordPage />} />
                            <Route path="/auth" element={<LoginPage />} />
                            <Route path="/join-team/:token" element={<RegisterOrganizationMemberPage />} />
                        </Route>

                        <Route element={<ProtectedRoute />}>
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/deep-analysis" element={<DeepAnalysisDashboardPage />} />
                            <Route path="/deep-analysis/setup-domain" element={<NewWebsitePage />} />
                            <Route path="/deep-analysis/failed-check/:seoTestKey" element={<FailedCheckPage />} />
                            <Route path="/deep-analysis/monitored-urls" element={<ServiceableUrlsPage />} />
                            <Route path="/deep-analysis/page-group" element={<UrlClusterPage />} />
                            <Route path="/deep-analysis/report" element={<SeoAuditReportPage />} />
                            <Route path="/ai-content-analysis" element={<AIContentAnalysisPage />} />
                            <Route path="/llm-visibility-analysis" element={<LLMVisibilityAnalysisPage />} />
                            <Route path="/visual-seo-analysis" element={<VisualSeoAnalysisPage />} />
                            <Route path="/analysis" element={<AnalysisPage />} />
                            <Route path="/analysis/report" element={<AnalysisReportPage />} />
                            <Route path="/backlinks" element={<BacklinksPage />} />
                            <Route path="/top-keywords" element={<TopKeywordsPage />} />
                            <Route path="/keyword-position" element={<KeywordPositionPage />} />
                            <Route path="/keyword-research" element={<KeywordResearchPage />} />
                            <Route path="/site-speed" element={<SiteSpeedPage />} />
                            <Route path="/site-outage" element={<SiteOutagePage />} />
                            <Route path="/white-label/templates/:id" element={<WhiteLabelPage />} />
                            <Route path="/white-label/templates" element={<WhiteLabelPage />} />
                            <Route path="/white-label/reports" element={<WhiteLabelPage />} />
                            <Route path="/user/account/profile" element={<UserAccountPage />} />
                            <Route path="/user/team-members" element={<TeamMembersPage />} />
                            <Route path="/dashboard/settings/:section" element={<DashboardSettingsPage />} />
                            <Route path="/subscription/plans" element={<SubscriptionPlansPage />} />
                            <Route path="/subscription/checkout/:planCode" element={<SubscriptionCheckoutPage />} />
                            <Route path="/user/account/billing" element={<BillingInfoPage />} />
                            <Route path="/user/account/setup" element={<AccountSetupPage />} />
                            <Route path="/free-trial-setup" element={<FreeTrialSetupPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                    </Routes>
                </AccessControl>
            </div>
        </div>
    );
}
